
export const statusData = [
    { name: "Non débutée", id: "pending" },
    { name: "En cours", id: "started" },
    { name: "Terminée", id: "finished" },
]

export const equipmentstatusData = [
    { name: "Aucun point sur cet équipement", id: 0 },
    { name: "Inactif", id: 1 },
    { name: "Actif", id: 2 },
    { name: "Partiellement Actif", id: 3 },
]

export const equipmentinstalledData = [
    { name: "Non installé", id: "noninstalled" },
    { name: "Installé", id: "installed" },
    { name: "Désinstallé", id: "uninstalled" },
]

export const chartsourceData = [
    { name: "Graphique existant", id: "existing" },
    { name: "Point de donnée", id: "point" },
    { name: "Type de donnée", id: "definition" },
]

export const chartseriesourceData = [
    { name: "Point de donnée", id: "point" },
    { name: "Type de donnée", id: "definition" },
    { name: "Valeur fixe", id: "fixedvalue" },
]

export const charttypepointData = [
    { name: "Histogramme", id: "column" },
    { name: "Courbe", id: "line" },
    { name: "Aire", id: "area" },
]

export const charttypefullData = [
    { name: "Histogramme empilé", id: "columnstacked" },
    { name: "Histogramme", id: "column" },
    { name: "Courbe", id: "line" },
    { name: "Aire", id: "area" },
    { name: "Tableau", id: "tab" },
    { name: "Camembert", id: "pie" },
]

export const charttypeadvancedData = [
    { name: "Histogramme empilé", id: "columnstacked" },
    { name: "Histogramme", id: "column" },
    { name: "Courbe", id: "line" },
    { name: "Aire", id: "area" },
]

export const chartgranularityData = [
    { name: "Horaire", id: "hour" },
    { name: "Journalière", id: "day" },
    { name: "Hebdomadaire", id: "week" },
    { name: "Mensuelle", id: "month" },
    { name: "Annuelle", id: "year" },
]
export const chartgranularityfullData = [
    { name: "10 minutes", id: "10minutes" },
    { name: "Horaire", id: "hour" },
    { name: "Journalière", id: "day" },
    { name: "Hebdomadaire", id: "week" },
    { name: "Mensuelle", id: "month" },
    { name: "Annuelle", id: "year" },
]

export const chartfixedvaluetypeData = [
    { name: "Valeur fixe", id: "fixed" },
    { name: "Valeur du patrimoine", id: "realestate" },
]

export const chartaxisData = [
    { name: "Axe de gauche", id: "left" },
    { name: "Axe de droite", id: "right" },
]

export const realestatevalueData = [
    { name: "Seuil CO2 qualité d’air modérée", id: "moderateairqualityco2threshold" },
    { name: "Seuil CO2 qualité d’air basse", id: "lowairqualityco2threshold" },
    { name: "Température réduite", id: "reducedtemperature" },
    { name: "Température de confort", id: "comforttemperature" },
    { name: "Limite environnement sec", id: "lowhumiditylevel" },
    { name: "Limite environnement humide", id: "highhumiditylevel" },
]